export default "__VITE_ASSET__NJQ0Hfq4__"